/** Formato del importe de rebaja para el mensaje al cliente. */
export function formatImporteRebaja(importe) {
  const n = Math.round(Number(importe) || 0);
  return `${n.toLocaleString('es-ES')} €`;
}

/** Mensaje por defecto según hora del día (mañana / tarde). */
export function mensajeDefaultBajada(importe) {
  const h = new Date().getHours();
  const saludo = h < 14 ? 'Buenos días' : 'Buenas tardes';
  const rebaja = formatImporteRebaja(importe);
  return `${saludo}, esta propiedad que tenías interés ha bajado ${rebaja} de precio. Pégale un vistazo y dime si te apetece volver a verla. Un saludo.`;
}

export const ETAPA_LEAD_LABEL = {
  leads: 'Leads',
  atendidos: 'Atendidos',
  visitantes: 'Visitantes',
  calientes: 'Calientes',
  frios: 'Fríos',
  ventas: 'Ventas',
};

export function etiquetaEtapaLead(etapa) {
  const k = String(etapa || '').trim().toLowerCase();
  return ETAPA_LEAD_LABEL[k] || (k ? k.charAt(0).toUpperCase() + k.slice(1) : '—');
}
